import '../../../assets/style/HPC5.css';
import "react-multi-carousel/lib/styles.css";

import use1 from "../../../assets/photo/usecase1.webp"
import use2 from "../../../assets/photo/usecase2.webp"
import { useTranslation } from "react-i18next";
import { Link} from "react-router-dom";

function HPC5() {
    const { t } = useTranslation();

    return(
        <section className="HPC5">

            <div className='imgHPC5'>
                <img src={use1} alt="usecase1" />
                <img src={use2} alt="usecase2" />
            </div>
            <div className='tHPC5'>
                <p className='titleHPC5'>Portfolio</p>
                <p className='textHPC5'>{t("hpc5text")}</p>
                <Link to={"/demo"} className='btnSelengkap'>{t("selengkap")}</Link>
            </div>

        </section>
    );
};

export default HPC5;